<template>
  <div>
    <q-header class="bg-primary text-black">
      <q-toolbar style="height: 80px">
        <!-- <q-btn
          flat
          @click="toggleNav"
          color="headerButton"
          round
          dense
          icon="menu"
        ></q-btn> -->
        <q-img
          src="/statics/WavesLogoWhite.png"
          style="height: 80%"
          contain
        ></q-img>
        <!-- <h3
          style="font-size: 24px"
          class="q-my-none text-bold text-white text-center full-width"
        >
          Waves Results
        </h3> -->
      </q-toolbar>
    </q-header>

    <!-- <q-drawer
      :mini="miniState"
      v-model="drawer"
      show-if-above
      :width="200"
      :breakpoint="400"
      elevated
    >
      <q-img class="bg-white userInfoSection" style="height: 200px">
        <div class="absolute-bottom bg-white">
          <q-avatar
            v-if="!miniState"
            size="56px"
            class="q-mb-sm bg-white"
            style="cursor: pointer"
            @click="$router.push('/userProfile')"
          >
            <img :src="currentUserData.profileImageUrl" />
          </q-avatar>
          <div class="row">
            <div v-if="!miniState" class="col-12">
              <div
                class="text-weight-bold text-accent"
                style="cursor: pointer"
                @click="$router.push('/userProfile')"
              >
                {{ currentUserData.name }} - {{ currentUserData.role }}
              </div>
              <div
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 100%;
                  cursor: pointer;
                "
                class="text-accent"
                @click="$router.push('/userProfile')"
              >
                {{ currentUserData.email }}
              </div>
            </div>
            <div v-if="!miniState" class="col-12">
              <q-btn
                label="Logout"
                color="primary"
                @click="$store.dispatch('auth/logout')"
                icon="mdi-logout"
                class="full-width"
                dense
                no-caps
              >
                <q-tooltip> Logout </q-tooltip>
              </q-btn>
            </div>
          </div>
        </div>
      </q-img>
      <div class="bg-white navBarLogo text-center">
        <h3 class="q-my-none">
          <q-btn-dropdown
            v-if="
              ['Admin', 'Waves Manager', 'Sport Manager'].includes(
                currentUserData.role
              )
            "
            class="full-width text-capitalize"
            color="primary"
            :label="`${miniState ? '' : siteArea}`"
          >
            <q-list>
              <q-item
                clickable
                v-close-popup
                @click="
                  $store.dispatch('settings/changeSiteArea', 'Design');
                  $router.push('/');
                "
              >
                <q-item-section>Design</q-item-section>
              </q-item>
              <q-separator />
              <q-item
                clickable
                v-close-popup
                @click="
                  $store.dispatch('settings/changeSiteArea', 'Entries');
                  $router.push('/');
                "
              >
                <q-item-section>Entries</q-item-section>
              </q-item>
              <q-separator />
              <q-item
                clickable
                v-close-popup
                @click="
                  $store.dispatch('settings/changeSiteArea', 'Waves');
                  $router.push('/');
                "
              >
                <q-item-section>Waves</q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
          <span v-else>{{ siteArea }}</span>
        </h3>
      </div>
      <q-scroll-area
        style="height: calc(100% - 250px); border-right: 1px solid #ddd"
        class="bg-white"
      >
        <q-list padding class="text-accent">
          <div
            :key="`navLink_${index}`"
            v-for="(link, index) in displayedLinks"
          >
            <div
              v-if="
                competition &&
                $route.name &&
                $route.name.includes('waves') &&
                link.name == 'wavesCompetitionsMarshalling'
              "
              class="text-center q-py-md text-bold"
              style="
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ competition.competition_name }}
              <q-tooltip>
                {{ competition.competition_name }}
              </q-tooltip>
            </div>
            <q-item
              v-if="
                !link.children &&
                !$route.params[link.hideOnPathID] &&
                (!link.showOnPathID || $route.params[link.showOnPathID])
              "
              v-ripple
              :to="link.to"
              :exact="!link.disableExact"
              active-class="activePage"
            >
              <q-item-section avatar>
                <q-icon
                  v-if="link.icon && !link.customIconSrc"
                  :color="link.iconColor ? link.iconColor : 'accent'"
                  :name="link.icon"
                ></q-icon>
                <q-img v-if="link.customIconSrc" :src="link.customIconSrc">
                </q-img>
                <q-tooltip v-if="miniState">{{ link.text }}</q-tooltip>
              </q-item-section>
              <q-item-section> {{ link.text }} </q-item-section>
            </q-item>
            <q-expansion-item
              v-else-if="
                !$route.params[link.hideOnPathID] &&
                (!link.showOnPathID || $route.params[link.showOnPathID])
              "
              :ref="link.text"
              :group="link.text"
              :icon="link.icon"
              :label="link.text"
              expand-icon-class="activePage"
            >
              <q-list padding class="text-accent">
                <div
                  :key="`navLink_${childIndex}`"
                  v-for="(child, childIndex) in link.children"
                >
                  <q-item
                    v-if="!child.children"
                    v-ripple
                    :to="child.to"
                    :exact="!link.disableExact"
                    active-class="activePage"
                  >
                    <q-item-section avatar>
                      <q-icon
                        :color="child.iconColor ? child.iconColor : 'accent'"
                        :name="child.icon"
                      ></q-icon>
                      <q-tooltip v-if="miniState">{{ link.text }}</q-tooltip>
                    </q-item-section>
                    <q-item-section> {{ child.text }} </q-item-section>
                  </q-item>
                </div>
              </q-list>
            </q-expansion-item>
          </div>

          <q-item
            v-if="currentUserData.impersonatingUser == true"
            v-ripple
            clickable
            @click="stopImpersonation"
          >
            <q-item-section avatar>
              <q-icon color="accent2" name="cancel"></q-icon>
            </q-item-section>

            <q-item-section> Stop Impersonation </q-item-section>
          </q-item>
        </q-list>
      </q-scroll-area>
    </q-drawer> -->
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import autocomplete from "@/components/wrappers/autocomplete/autocomplete.vue";

  export default {
    components: { autocomplete },

    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        miniState: "settings/miniNavState",
        siteArea: "settings/siteArea",
        associations: "associations/list",
        associationsLoading: "associations/listLoading",
        competition: "competitions/current",
      }),
    },

    data: () => ({
      drawer: false,

      // Navigation
      rolesAccess: {},
      displayedLinks: [],
      links: [],

      siteAreaMenu: false,

      changeAssociation_id: null,
    }),
    watch: {
      currentUserData: function () {
        // this.setLinks();
      },
    },
    beforeCreate() {},
    mounted() {},
    methods: {
      setLinks() {
        this.displayedLinks = this.checkLinkPerms(this.links);
      },
      checkLinkPerms(links) {
        let newLinks = [];
        links.forEach((link) => {
          let newLink = JSON.parse(JSON.stringify(link));
          if (
            this.rolesAccess[this.currentUserData["role"]].includes(link.name) &&
            link.siteArea.includes(this.siteArea)
          ) {
            if (newLink.idInPath) {
              let regex = /:.*/;
              let value = newLink.to.match(regex)[0].split("/")[0];

              newLink.to = newLink.to.replace(
                value,
                this.$route.params[value.substring(1)]
              );
            }

            if (link.children) {
              newLink.children = this.checkLinkPerms(link.children);
            }
            newLinks.push(newLink);
          }
        });
        return newLinks;
      },
      toggleNav() {
        if (this.$q.screen.lt.sm) {
          this.drawer = !this.drawer;
        } else {
          this.$store.dispatch("settings/togglMiniNav");
        }
      },
      stopImpersonation() {
        this.$store.dispatch("auth/impersonateStop");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .activePage {
    border-left: 3px solid $primary;
    background-image: linear-gradient(
      to left,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.2)
    );

    div {
      color: $primary;
    }

    i {
      color: $primary;
    }
  }
  .userInfoSection {
    border-right: 1px solid white;
    border-bottom: 1px solid $accent2;

    #userInfoDiv:hover {
      background: black;
    }
  }
  .navBarLogo {
    height: 50px;
    border-right: 1px solid white;
    h3 {
      color: white;
      text-align: center;
      font-size: 12pt;
      font-weight: bold;
    }
  }
</style>
